import classNames from 'classnames'
import type { ReactNode } from 'react'

import cn from './AtomSwitch.module.scss'

export type AtomSwitchOption<T extends string> = {
  value: T
  label: string
  icon?: ReactNode
}

type AtomSwitchProps<T extends string> = {
  options: AtomSwitchOption<T>[]
  value: T
  onChange: (value: T) => void
  ariaLabel: string
  isOrganisationSelected?: boolean
  className?: string
}

function AtomSwitch<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  isOrganisationSelected = false,
  className,
}: AtomSwitchProps<T>) {
  const activeIndex = Math.max(
    options.findIndex((option) => option.value === value),
    0
  )

  return (
    <div
      className={classNames(
        cn.switch,
        isOrganisationSelected && cn.organisationSelected,
        className
      )}
      role="tablist"
      aria-label={ariaLabel}
      style={{
        '--switch-count': options.length,
        '--switch-index': activeIndex,
      }}
    >
      <span className={cn.indicator} aria-hidden />
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={option.value === value}
          className={classNames(
            cn.option,
            option.value === value && cn.optionActive
          )}
          onClick={() => onChange(option.value)}
        >
          {option.icon}
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default AtomSwitch
